import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import axios from 'axios';
import AdminNav from './AdminNav';
import config from '../../../function/config';
import Footer from '../../Footer';

export default function RegisterShipForSaleAdmin() {

  
const [isScrolled, setIsScrolled] = useState(false);
 useEffect(() => {
        const handleScroll = () => {
          setIsScrolled(window.scrollY > 50); // Adjust the value to when you want the effect
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);
      
  // Scroll to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
      
        
        const navigate = useNavigate()
        
          

          const [formType, setFormType] = useState("sale"); // Default to "sale"
          const [loading,setLoading] = useState(false)
          const[Title,setTitle] = useState('')
          const[vesselType,setvesselType] = useState('')
          const[ShortDescription,setShortDescription] = useState('')
          const[Flag,setFlag] = useState('')
          const[YearBuilt,setYearBuilt] = useState('')
          const[Capacity,setCapacity] = useState('')
          const[LOA,setLOA] = useState('')
          const[Class,setClass] = useState('')
          const[GRTNRT,setGRTNRT] = useState('')
          const[Teu,setTeu] = useState('')
          const[Price,setPrice] = useState('')
          const[MainEngine,setMainEngine] = useState('')
          const[DWT,setDWT] = useState('')
          const[SubType,setSubType] = useState('')
          const userId = localStorage.getItem("user_id");

          const[Email,setEmail] = useState('')
          const[MobileNO,setMobileNO] = useState('')
          const[BriefDescription,setBriefDescription] = useState('')
          const [images, setImages] = useState([]);
          const [ThumbnailImage, setThumbnailImage] = useState("");
          const [Image,setImage] = useState('')
          const [Nationality,setNationality] = useState('')
          const [BuyAsScrap,setBuyAsScrap] = useState('')
          const [From,setFrom] = useState('')
          const [To,setTo] = useState('')
          const [InspectionCountry,setInspectionCountry] = useState('')

          const [Category,setCategory] = useState('')
          const [Subject,setSubject] = useState('')
      const vesselSubTypes = {
  Barge: [" Cargo Barge","Tanker Barge", "Accommodation Barge", "Self-Propelled Barge"],
  Bulk: ["Handymax Bulk Carrier","Supramax Bulk Carrier","Ultramax Bulk Carrier","Panamax Bulk Carrier","Kamsarmax Bulk Carrier", "Mini Bulk Carrier","Post-Panamax Bulk Carrier", "Log Carrier", "Cement Carrier"],
  Cargo: ["General Cargo"],
  Container: ["Feeder Container Ship","Panamax Container Ship","Post-Panamax Container Ship","New Panamax (Neo-Panamax)","Mega Container carrier","Fully Cellular Container Ship","Container Barge"],
  Fishing: ["Longliner", "Purse Seiner","Shrimp Trawler","Stern Trawler"],
  Multipurpose: ["General Cargo + Container Ship","General Cargo + Bulk Carrier","Container + Ro-Ro Ship (ConRo)","Heavy Lift Multipurpose Vessel","Tweendecker (with multiple cargo decks)",'Livestock'],
  "Passenger/Ferry":["Cruise Ship","High-Speed Craft", "Catamaran Ferry", "Hydrofoil", "Hovercraft", "Day Passenger Vessel", "Water Taxi"],
  Reefer: ["Conventional Reefer Ship","Reefer Container Ship","Side Door Reefer Ship","Palletized Reefer Ship","Fish Reefer Vessel"],
  RoRo:["Pure Car Carrier (PCC)", "Ro-Ro Cargo Ship","Ro-Pax Ship (Ro-Ro + Passenger)","LOLO Cargo Ship","Double-Ended Ro-Ro"],
  Tanker: ["Crude Oil Tanker","Product Tanker","Chemical Tanker","LNG Carrier (Liquefied Natural Gas)","LPG Carrier (Liquefied Petroleum Gas)","Bitumen Tanker","Oil Recovery Vessel","Bunker vessel ","Slop Barge Tanker","Water Tanker", "Edible Oil Tanker"],
  Dredger: ["Cutter Suction Dredger","Hopper Dredger","Bucket Dredger","Backhoe Dredger","Grab Dredger"],
  "Floating Crane": ["Sheerleg Crane Vessel","Crane Barge","Jack-Up Crane Vessel","Derrick Barge","Floating Gantry Crane"],
  "Floating Dock": ["Pontoon-Type Floating Dock","Submersible Floating Dock","Ship-Lift Floating Dock","Floating Dry Dock"],
  "Landing Craft": ["Landing Craft Utility (LCU)","Landing Craft tanker"],
  Yacht:["Sailing Yacht","Motor Yacht","Catamaran Yacht","Trimaran Yacht","Superyacht","Megayacht","Flybridge Yacht"],
  "Tug Boat":["Harbor Tug","Ocean Tug","Escort Tug","Azimuth Stern Drive (ASD) Tug","Pusher Tug","Anchor Handling Tug (AHT)"],
  "Supply Boat":["Platform Supply Vessel (PSV)","Anchor Handling Tug Supply (AHTS)","Utility Vessel","Multi-Purpose Support Vessel (MPSV)","Diving Support Vessel (DSV)","Cable Laying Vessel","Accommodation Supply Vessel","DP Supply Boat (Dynamic Positioning)"],
  "Crew Boat": [" Fast Crew Boat","Fast Supply Intervention Vessel (FSIV)"],
  Other: [""]
};

          

          const [count,setCount] = useState(0)


         const [selectedImages, setSelectedImages] = useState([]); // Array of { file, preview }
         
         const handleImageChange = (e) => {
           const files = Array.from(e.target.files);
           const newImages = files.slice(0, 3 - images.length).map((file) => ({
             file,
             preview: URL.createObjectURL(file),
           }));
         
           setImages((prevImages) => [...prevImages, ...newImages]);
         };
         
         const removeImage = (index) => {
           const updated = [...images];
           updated.splice(index, 1);
           setImages(updated);
         };

         const [generatedCode, setGeneratedCode] = useState("");
        
          const normalize = (str) => str.toLowerCase().replace(/[^a-z]/g, "");

const subCategoryPrefixes = {
  barge: "BRG",
  bulk: "BLK",
  cargo: "CRG",
  container: "CNT",
  fishing: "FIS",
  multipurpose: "MPP",
  passengerferry: "PAX",
  reefer: "REF",
  roro: "ROR",
  tanker: "TNK",
  tugboat: "TUG",
  dredger: "DRG",
  floatingcrane: "FLC",
  landingcraft: "LCT",
  yacht: "YCT",
  supplyboat: "SUB",
  crewboat: "CRB",
  floatingdock: "FLD",
  Other: "OTR"
};

useEffect(() => { 
  if (vesselType) {
    const normalized = normalize(vesselType);
    const prefix = subCategoryPrefixes[normalized];
    if (prefix) {
      setGeneratedCode(prefix); // ✅ Only set the prefix
    } else {
      setGeneratedCode("");
    }
  }
}, [vesselType]);

const ID = localStorage.getItem("user_id");
const token = localStorage.getItem('token')

          // register ship
          const handleSubmitSale = async(e,id)=>{
            e.preventDefault();
           
            setLoading(true)
            const formData = new FormData();
  
            // Append text fields
            formData.append("title", Title);
            formData.append("vessel_type", vesselType);
            formData.append("sub_type", SubType);
            formData.append("short_description", ShortDescription);
            formData.append("flag", Flag);
            formData.append("year_built", YearBuilt);
            formData.append("capacity", Capacity);
            formData.append("LOA", LOA);
            formData.append("Class", Class);
            formData.append("GRT_NRT", GRTNRT);
            formData.append("Teu", Teu);
            formData.append("main_engine", MainEngine);
            formData.append("DWT", DWT);
            formData.append("Price", Price);
            formData.append("email", Email);
            formData.append("phone", MobileNO);
            formData.append("brief_description", BriefDescription);
            formData.append("ship_code", generatedCode)
  

            // Append images
    
  
    // Append multiple images
    if (images.length > 0) {
      images.forEach((imgObj) => {
        formData.append("image", imgObj.file); // ✅ file is the File object
      });
    }
  
            try {
              console.log("Generated Ship Code:", generatedCode);

                const response = await axios.post(`${config.base_url}/api/HappyMarineShipping/AddShipForSale`,formData,{
                  headers:{
                    'Content-Type':'multipart/form-data',
                    Authorization: `Token ${token}`,
                  }
                });
                if(response.data.status===200){
                  navigate('/adminHome')
                  console.log(response)
                  setLoading(false)
                  toast.success("Ship Registered Successfully!",{
                    autoClose:1500,
                    position:'top-right',
                    
                  });
                  setCount(id)
                 
                  setvesselType('')
                  setShortDescription('')
                  setFlag('')
                  setCapacity('')
                  setClass('')
                  setDWT('')
                  setEmail('')
                  setImage('')
                  setMobileNO('')
                  setMainEngine('')
                  setGRTNRT('')
                  setLOA('')
                  setPrice('')
                  setYearBuilt('')
                  setTeu('')
                  setGRTNRT('')
                  setBriefDescription('')
                  
                }
                else{
                    setLoading(false)
                  console.log("error1")
                  toast.error("Fill the required Fields",{
                    autoClose:1500,
                    position: "top-right",
                  })
                }
                
              } catch (err) {
                setLoading(false)
                console.log("error2",err)
                toast.error("Error",{
                  autoClose:2000,
                  position: "top-right",
                })
              }
            
        }

      

        const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
    

  
    const [listening, setListening] = useState(false);
  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = SpeechRecognition ? new SpeechRecognition() : null;
    if (recognition) {
      recognition.continuous = true; // Allow continuous listening
      recognition.interimResults = false; // Only get final results
    }
  
  
    const handleTranscript = (lower) => {
      // Vessel Type
      const vesselTypes = [
        "barge", "bulk", "cargo", "container", "fishing", "multipurpose",
        "passenger", "reefer", "roro", "tanker", "dredger", "floating crane",
        "landing craft", "Yacht", "tug boat", "supply boat", "crew boat", "other"
      ];
      vesselTypes.forEach((type) => {
        if (lower.includes(type)) setvesselType(capitalizeWords(type));
      });
    
      const flagMatch = lower.match(/flag (is )?([a-z\s]+)/);
      if (flagMatch) setFlag(capitalizeWords(flagMatch[2].trim()));
    
      const yearMatch = lower.match(/\b(19|20)\d{2}\b/);
      if (yearMatch) setYearBuilt(yearMatch[0]);
    
      const capMatch = lower.match(/capacity (is )?([\d,\.]+\s*\w*)/);
  if (capMatch) setCapacity(capMatch[2].trim());
  
      const loaMatch = lower.match(/l o a (is )?([\d,\.]+\s*\w*)/);
  if (loaMatch) setLOA(loaMatch[2].trim());
    
  const grtMatch = lower.match(/grt(?:\/nrt)?(?: is)?(?: of)? ([\d,\.]+\s*\w*)/);
  if (grtMatch) setGRTNRT(grtMatch[1].trim());
  
      const teuMatch = lower.match(/(?:t e u|hp).{0,10}?(\d+(\.\d+)?)/i) || lower.match(/(\d+(\.\d+)?).{0,5}?(teu|hp)/i);
      if (teuMatch) setTeu(teuMatch[1]);
    
      let emailText = lower.replace(/ at /g, "@").replace(/ dot /g, ".");
      const emailMatch = emailText.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}/);
      if (emailMatch) setEmail(emailMatch[0]);
    
      // Replace spoken words like "plus" and "zero"
  let cleaned = lower
  .toLowerCase()
  .replace(/plus/g, "+")
  .replace(/zero/g, "0")
  .replace(/ at /g, "@")
  .replace(/ dot /g, ".")
  .replace(/[\s\-]/g, ""); // remove spaces and dashes
  
  const mobileMatch = cleaned.match(/(\+?\d{10,15})/);
  if (mobileMatch) {
  setMobileNO(mobileMatch[1]);
  }
  
    
      const classMatch = lower.match(/class (is )?([a-zA-Z0-9]+)/);
      if (classMatch) setClass(classMatch[2].toUpperCase());
    
      const engineMatch = lower.match(/main engine (is )?([a-zA-Z0-9\s\-]+)/);
      if (engineMatch) setMainEngine(capitalizeWords(engineMatch[2].trim()));
    
      const dwtMatch = lower.match(/dwt (is )?([\d,\.]+\s*\w*)/);
  if (dwtMatch) setDWT(dwtMatch[2].trim());
  
    
  const priceMatch = lower.match(/price (is )?([\d,\.]+\s*\w*)/);
  if (priceMatch) setPrice(priceMatch[2].trim());
  
    
      if (lower.includes("short description")) {
        const shortDesc = lower.split("short description")[1]?.trim();
        if (shortDesc) setShortDescription(capitalizeWords(shortDesc));
      }
    
      if (lower.includes("particular") || lower.includes("brief description")) {
        const brief = lower.split("particular").pop()?.trim() ||
                      lower.split("brief description").pop()?.trim();
        if (brief) setBriefDescription(capitalizeWords(brief));
      }
    };
    
  const startListening = () => {
    if (!recognition) {
      alert("Speech Recognition is not supported in this browser");
      return;
    }
  
    setListening(true);
    recognition.start();
  
    recognition.onresult = (event) => {
      for (let i = event.resultIndex; i < event.results.length; ++i) {
        if (event.results[i].isFinal) {
          const transcript = event.results[i][0].transcript;
          console.log("Voice Input:", transcript);
          handleTranscript(transcript.toLowerCase());
        }
      }
    };
  };
  
  // Utility function to capitalize words
  const capitalizeWords = (text) =>
    text.replace(/\b\w/g, (char) => char.toUpperCase());
  

        
  return (
    <div className='bg-gradient-to-r from-[#2e5775] to-[#326e99] '>

        <AdminNav/>

        <section className='mt-14 mb-10'>
        <div className="py-10 px-[30px] xm:px-[10px] w-[80%] lg:w-[90%] m-auto border rounded border-white">
      {/* Links for selecting form type */}
      <div className="flex justify-center gap-8 lg:flex-wrap lg:gap-5 items-center">
        <button
          onClick={() => setFormType("sale")}
          className='text-white text-2xl mb-3 font-bold'
        >
          Register Ship For Sale
        </button>
        
      </div>

      {/* Conditional Form Rendering */}
      <Link to={'/regShipadmin'} className='px-3  text-white'><i className='fa-solid fa-beat fa-arrow-left '></i> Back</Link>
      {formType === "sale" && (
            <form className="bg-white mt-2  rounded w-[100%]">
             <div className='p-5'>
                    <h1 className='text-black font-bold text-xl'>Register Ship For Sale</h1>
                </div>
              <hr className="text-gray-100 w-full" />
               <div className="absolute xm:right-16  right-56 mt-2 z-10"> 

              <button 
  type="button"
  onClick={() => {
    if (listening) {
      recognition.stop();      // Stop if currently listening
      setListening(false);
    } else {
      startListening();        // Start if not listening
    }
  }}
  className={`px-4 py-2 rounded-full shadow-lg transition-all ${
    listening ? 'bg-red-100 animate-pulse' : 'bg-gray-100'
  }`}
>
  {listening ? (
    <i className="fa-solid fa-stop text-red-600 text-xl"></i> // Stop icon
  ) : (
    <i className="fa-solid fa-microphone text-xl"></i>        // Mic icon
  )}
</button>

</div>
              {/*Title & vessel type */}
              <div className="p-5 flex gap-5 items-center xm:flex-wrap xm:gap-5">
                
                <div className=" w-[100%]">
                  <label htmlFor="VesselType" className="font-semibold">
                    Vessel Type
                  </label>
                  <select
                    value={vesselType}
                    onChange={(e) => setvesselType(e.target.value)}
                    className="w-full mt-4 rounded border border-gray-400 p-2 text-[#d1a460]"
                    name="vesselType"
                    id="VesselType"
                  >
                    <option hidden selected value="">
                      -Select-
                    </option>
                    <option
                      disabled
                      className="text-gray-500 font-semibold"
                      value=""
                    >
                      Catagories
                    </option>
                    <option value="Barge" className="text-gray-500">
                      Barge
                    </option>
                    <option value="Bulk" className="text-gray-500">
                      Bulk
                    </option>
                    <option value="Cargo" className="text-gray-500">
                      Cargo
                    </option>
                    <option value="Container" className="text-gray-500">
                      Container
                    </option>
                    <option value="Fishing" className="text-gray-500">
                      Fishing
                    </option>
                    <option value="Multipurpose" className="text-gray-500">
                      Multipurpose
                    </option>
                    <option value="Passenger/Ferry" className="text-gray-500">
                      Passenger/Ferry
                    </option>
                    <option value="Reefer" className="text-gray-500">
                      Reefer
                    </option>
                    <option value="RoRo" className="text-gray-500">
                      RoRo
                    </option>
                    <option value="Tanker" className="text-gray-500">
                      Tanker
                    </option>
                    <option value="Dredger" className="text-gray-500">
                      Dredger
                    </option>
                    <option value="Floating Crane" className="text-gray-500">
                      Floating Crane
                    </option>
                    <option value="Floating Dock" className="text-gray-500">
                      Floating Dock
                    </option>
                    <option value="Landing Craft" className="text-gray-500">
                      Landing Craft
                    </option>
                    <option value="Yacht" className="text-gray-500">
                      Yacht
                    </option>
                    <option value="Tug Boat" className="text-gray-500">
                      Tug Boat
                    </option>
                    <option value="Supply Boat" className="text-gray-500">
                      Supply Boat
                    </option><option value="Crew Boat" className="text-gray-500">
                      Crew Boat
                    </option>
                    <option value="Other" className="text-gray-500">
                      Other
                    </option>
                  </select>
                </div>

                {vesselType && vesselSubTypes[vesselType] && (
  <div className="w-[100%]">
    <label htmlFor="SubType" className="font-semibold">
      Vessel Sub-Type
    </label>
    <select
      value={SubType}
      onChange={(e) => setSubType(e.target.value)}
      className="w-full mt-4 rounded border border-gray-400 p-2 text-[#d1a460]"
      name="SubType"
      id="SubType"
    >
      <option hidden value="">
        - Select Sub-Type -
      </option>
      {vesselSubTypes[vesselType].map((sub, idx) => (
        <option key={idx} value={sub.trim()}>
          {sub.trim()}
        </option>
      ))}
    </select>
  </div>
)}


                {generatedCode && (
  <div className="w-[50%] xm:w-[100%]">
    <label htmlFor="GeneratedCode">Reference Id</label>
    <input
      value={generatedCode}
      onChange={(e)=> setGeneratedCode(e.target.value)}
      className="w-full mt-2 rounded border border-gray-400 p-2 text-gray-500"
      id="GeneratedCode"
      disabled
    />
  </div>
)}
              </div>

               {/* short description */}
              <div className="p-5">
                <label htmlFor="shortDescription" className="font-semibold">
                  Short Description
                </label>
                <textarea
                  placeholder="Enter Ship Name/Type/Yr Built/Country/DWT"
                  value={ShortDescription}
                  onChange={(e) => setShortDescription(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="shortDescription"
                ></textarea>
              </div>

              {/* flag and Year Built*/}
              <div className="p-5 flex  xm:flex-wrap gap-5 items-center ">
                <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                  <label htmlFor="Flag" className="font-semibold">
                    Flag
                  </label>
                  <input
                    placeholder="Enter the Country Name"
                    value={Flag}
                    onChange={(e) => setFlag(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="Flag"
                  />
                </div>
                {/* Year Built */}
                <div className="w-[50%] xm:w-[100%]">
                  <label htmlFor="Year Built" className="font-semibold">
                    Year Built
                  </label>
                  <input
                  
                    placeholder="Enter the Year"
                    value={YearBuilt}
                    onChange={(e) => setYearBuilt(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="Year Built"
                  />
                </div>
              </div>

              {/* Capacity and LOA */}
              <div className="p-5 flex gap-5 items-center xm:flex-wrap ">
                {/* <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                  <label htmlFor="Capacity" className="font-semibold">
                    Capacity
                  </label>
                  <input
                    value={Capacity}
                    onChange={(e) => setCapacity(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    placeholder="Enter the Capacity"
                    name=""
                    id="Capacity"
                  />
                </div> */}
                <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                  <label htmlFor="Length of all" className="font-semibold">
                    Length of all:LOA(m)
                  </label>
                  <input
                    value={LOA}
                    onChange={(e) => setLOA(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="Length of all"
                    placeholder="Enter LOA"
                  />
                </div>
              </div>

              {/* class */}
              <div className="p-5 flex gap-5 items-center xm:flex-wrap xm:gap-5">
                <div className="flex flex-col gap-1 w-[35%] xm:w-[100%]">
                  <label htmlFor="Class" className="font-semibold">
                    Class
                  </label>
                  <input
                    value={Class}
                    onChange={(e) => setClass(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    placeholder="Enter the Class"
                    name=""
                    id="Class"
                  />
                </div>

                <div className="flex flex-col gap-1 w-[35%] xm:w-[100%]">
                  <label htmlFor="GRT/NRT" className="font-semibold">
                    GRT/NRT
                  </label>
                  <input
                    value={GRTNRT}
                    onChange={(e) => setGRTNRT(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="GRT/NRT"
                    placeholder="Enter GRT/NRT"
                  />
                </div>

                <div className="flex flex-col gap-1 w-[35%] xm:w-[100%]">
                  <label htmlFor="Teu" className="font-semibold">
                    TEU/HP
                  </label>
                  <input
                    value={Teu}
                    onChange={(e) => setTeu(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="Teu"
                    placeholder="Enter TEU/HP"
                  />
                </div>
              </div>

              {/* main engine dwt */}
              <div className="p-5 flex gap-5 items-center xm:flex-wrap xm:gap-5">
                <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                  <label htmlFor="Main Engine" className="font-semibold">
                    Main Engine
                  </label>
                  <input
                    value={MainEngine}
                    onChange={(e) => setMainEngine(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="Main Engine"
                    placeholder="Enter Main Engine"
                  />
                </div>

                <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                  <label htmlFor="DWT" className="font-semibold">
                    DWT
                  </label>
                  <input
                    value={DWT}
                    onChange={(e) => setDWT(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="DWT"
                    placeholder="Enter DWT"
                  />
                </div>
              </div>

              {/* Price and scrap */}
              <div className="p-5 ">
                <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                  <label htmlFor="Price" className="font-semibold">
                    Price(USD)
                  </label>
                  <input
                    value={Price}
                    onChange={(e) => setPrice(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="Price"
                    placeholder="Enter the Price"
                  />
                </div>
              </div>

              {/* Email Phone */}
              <div className="p-5 flex gap-5 items-center xm:flex-wrap xm:gap-5">
                <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                  <label htmlFor="Email" className="font-semibold">
                    Email
                  </label>
                  <input
                    value={Email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="Email"
                    placeholder="Enter your Email"
                  />
                </div>

                <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                  <label htmlFor="Mobile No" className="font-semibold">
                    Mobile No
                  </label>
                  <input
                    value={MobileNO}
                    onChange={(e) => setMobileNO(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="Mobile No"
                    placeholder="Enter Your Mobile No"
                  />
                </div>
              </div>

             

              {/* Brief Description */}
              <div className="p-5">
                <label htmlFor="Brief Description" className="font-semibold">
                  Ship Particular
                </label>
                <textarea
                  value={BriefDescription}
                  onChange={(e) => setBriefDescription(e.target.value)}
                  rows={5}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Brief Description"
                  placeholder="Write about your ship in brief...."
                ></textarea>
              </div>

              {/* upoad image */}
              {/* upoad image */}
              

              <div className="p-5">
  {/* Previews */}
  {images.length > 0 && (
  <div className="flex gap-4 mb-4 flex-wrap">
    {images.map((img, index) => (
        <div key={index} className="relative w-28 h-28">
          <img
            src={img.preview}
            alt={`preview ${index}`}
            className="w-full h-full  rounded border border-gray-300"
          />
          <button
            onClick={() => removeImage(index)}
            className="absolute top-0 right-0 bg-red-500 text-white text-xs px-1 rounded-bl"
            title="Remove"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  )}

  {/* Upload Field */}
  <label htmlFor="image" className="">
    Upload Images (Max 3 Images)
  </label>
  <input
    type="file"
    onChange={handleImageChange}
    multiple
    accept="image/*"
    className="imageInput w-full mt-2 rounded border border-gray-400 text-gray-500 p-2"
    id="image"
    disabled={selectedImages.length >= 3}
  />
</div>


              <hr className="text-gray-500 w-full" />
              <div className="p-4">
                <button
                  onClick={(e) => handleSubmitSale(e)}
                  type="submit"
                  className="bg-green-600 hover:bg-green-500 text-white px-3 py-2 rounded"
                >
                  {loading ? (
                    <span className="block w-[16px] h-[16px] border-2 border-b-0 border-white mt-[4px] mb-[4px] rounded-full m-auto animate-spin"></span>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </form>
          )}

      
    </div>
        
        
        </section>
    

    
    {/* Go to Top Button */}
    {isScrolled && (
  <div
    className="fixed bottom-16 right-8 z-50 " // Ensure it's in the right position with high z-index
  >
    <div
      className="back-to-top px-4 hover:bg-[#615d91]"
      onClick={scrollToTop}
    >
      <i className="fa-solid fa-arrow-up text-2xl"></i>
    </div>
  </div>
)}
     
    <Footer/>
      
    </div>
  )
}
